import { paginator } from "./paginator";
import { dropdown } from "./dropdown";
import { tabview } from "./tabview";
import { tabpanel } from "./tabpanel";
import { galleria } from "./galleria";
import { accordion } from "./accordion";
import { overlaypanel } from "./overlaypanel";

export const primeReactStyles = {
  paginator,
  dropdown,
  tabview,
  tabpanel,
  galleria,
  accordion,
  overlaypanel
};
